import React, { FC } from 'react'
import { Card, Typography } from '@material-ui/core'

import { useStyles } from './styles'

interface FormDataProps {
  formData: any
}

export const AsidePreview: FC<FormDataProps> = ({ formData }) => {
  console.log(formData)

  const classes = useStyles()

  return (
    <div className={classes.mainBody}>
      <Typography variant="h5" className={classes.blockName}>
        Preview:
      </Typography>
      {formData && (
        <Card className={classes.card}>
          <Typography variant="body2" className={classes.name}>
            {formData?.title}
          </Typography>

          <Typography variant="body2">
            Subtítulo: {formData?.subtitle}
          </Typography>

          <Typography variant="body2">Tipo: {formData?.type}</Typography>

          <Typography variant="body2">Subtipo: {formData?.subtype}</Typography>

          <Typography variant="body2" className={classes.release}>
            Lançamento: {formData?.released_at}
          </Typography>

          <Typography variant="body2">Slug: {formData?.slug}</Typography>

          <Typography variant="body2">Ordem: {formData?.order}</Typography>
        </Card>
      )}
    </div>
  )
}
